module.exports = __webpack_public_path__ + "img/eye.50a647a0.svg";